// extracted by mini-css-extract-plugin
module.exports = {"types":"Tabs_types__2q56h","type":"Tabs_type__2xDZL","type__active":"Tabs_type__active__219Si","typeBtn":"Tabs_typeBtn__3qXkG","rotating":"Tabs_rotating__1HH-1"};